import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eedb340e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper-container" }
const _hoisted_2 = { class: "question-header" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "question-content"
}
const _hoisted_5 = { class: "question-footer" }
const _hoisted_6 = { style: {"margin-left":"2px"} }
const _hoisted_7 = {
  key: 2,
  class: "question-answer-container"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "参考答案：略", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "mark-record-container"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "阅卷信息", -1))
const _hoisted_12 = { class: "answer-table-box" }
const _hoisted_13 = { class: "answer-table" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "评分标准", -1))
const _hoisted_16 = { class: "hl" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "总分", -1))
const _hoisted_19 = { class: "hl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomAudio = _resolveComponent("CustomAudio")!
  const _component_Image = _resolveComponent("Image")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_EyeOutlined = _resolveComponent("EyeOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ClockCircleOutlined = _resolveComponent("ClockCircleOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.question.audioUrl)
        ? (_openBlock(), _createBlock(_component_CustomAudio, {
            key: 0,
            audioUrl: _ctx.question.audioUrl
          }, null, 8, ["audioUrl"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, _toDisplayString(_ctx.question.title), 1)
    ]),
    (_ctx.question.content || _ctx.question.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "question-content",
          innerHTML: _ctx.question.content || _ctx.question.description
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.question.contentPic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Image, {
            src: _ctx.question.contentPic,
            alt: "question content image"
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.showIde,
        shape: "round",
        size: "large"
      }, {
        default: _withCtx(() => [
          (_ctx.question.questionStatus === 'completed')
            ? (_openBlock(), _createBlock(_component_EditOutlined, { key: 0 }))
            : (_openBlock(), _createBlock(_component_EyeOutlined, { key: 1 })),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.answerMode
            ? '预览'
            : _ctx.question.questionStatus === 'completed'
            ? '去修改'
            : '开始答题'), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    (_ctx.answerMode && _ctx.hasPaperAnswer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true),
    (_ctx.answerMode && _ctx.markRecordData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (
                  _ctx.markRecordData.markRuleNameData &&
                  _ctx.markRecordData.markRuleNameData.length
                )
                    ? (_openBlock(), _createElementBlock("th", _hoisted_14))
                    : _createCommentVNode("", true),
                  _hoisted_15,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markRecordData.teacherData, (item) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: item.id
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.name), 1),
                      _createVNode(_component_a_popover, { overlayClassName: "popover-round" }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", null, "阅卷时间：" + _toDisplayString(_ctx.formatDateToSecond(item.start)) + "-" + _toDisplayString(_ctx.formatDateToSecond(item.end)), 1)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_ClockCircleOutlined, { style: {"color":"#8f96a3","font-size":"14px","margin-left":"5px"} })
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markRecordData.markRuleNameData, (rule, ruleIndex) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(ruleIndex + 1), 1),
                    _createElementVNode("td", null, _toDisplayString(rule), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markRecordData.teacherData, (item) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: item.id
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item[ruleIndex].markScore), 1),
                        _createElementVNode("span", _hoisted_16, "/" + _toDisplayString(item[ruleIndex].ruleScore) + "分", 1)
                      ]))
                    }), 128))
                  ]))
                }), 256))
              ]),
              _createElementVNode("tfoot", null, [
                _createElementVNode("tr", null, [
                  (
                  _ctx.markRecordData.markRuleNameData &&
                  _ctx.markRecordData.markRuleNameData.length
                )
                    ? (_openBlock(), _createElementBlock("th", _hoisted_17))
                    : _createCommentVNode("", true),
                  _hoisted_18,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.markRecordData.teacherData, (item) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: item.id
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.totalScore), 1),
                      _createElementVNode("span", _hoisted_19, "/" + _toDisplayString(item.totalPaperScore) + "分", 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}